import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Star } from 'lucide-react';
function StarRating({
  count = 5
}) {
  return <div className="flex gap-0.5" data-id="element-312">
      {[...Array(count)].map((_, i) => <Star key={i} className="w-4 h-4 text-[#FCD34D] fill-[#FCD34D]" data-id="element-313" />)}
    </div>;
}
export function TestimonialsSection() {
  const reviews = [{
    name: 'Sofía M.',
    role: 'Hija de paciente',
    text: 'No sabía cómo hablar con mi papá sin llorar. El capítulo de "El Arte de Acompañar" me dio las palabras exactas. Por fin pudimos tener una conversación real.'
  }, {
    name: 'Carlos R.',
    role: 'Esposo',
    text: 'Estaba agotado tratando de hacerlo todo yo. La tabla de roles nos salvó de peleas familiares. Ahora somos un equipo, no un desastre.'
  }, {
    name: 'Ana P.',
    role: 'Cuidadora principal',
    text: 'Me sentía muy culpable por tomarme descansos. Entender que "cuidarme es cuidar" cambió todo. Gracias por validar lo que sentía.'
  }, {
    name: 'Laura G.',
    role: 'Madre de familia',
    text: 'Tenía pánico de explicarle a mis hijos lo de su abuela. La guía para niños fue increíblemente útil y tierna.'
  }];
  return <section className="py-16 px-4 bg-[#EEF2F7] border-t border-[#E2E8F0]" data-id="element-314">
      <div className="max-w-[850px] mx-auto" data-id="element-315">
        <div className="text-center mb-10" data-id="element-316">
          <div className="inline-flex items-center gap-1.5 bg-[#E2E8F0] text-[#4A4A6A] px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-317">
            <CheckCircle className="w-3.5 h-3.5" data-id="element-318" />
            Historias Reales
          </div>
          <h2 className="text-2xl font-serif font-bold text-[#1C1C2E]" data-id="element-319">
            Familias que encontraron el camino
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10" data-id="element-320">
          {reviews.map((review, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-xl p-6 border border-[#E2E8F0] shadow-sm" data-id="element-321">
              <div className="mb-3" data-id="element-322">
                <StarRating data-id="element-323" />
              </div>
              <p className="text-[#4A4A6A] text-sm leading-relaxed mb-4 italic" data-id="element-324">
                "{review.text}"
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-[#F3F4F6]" data-id="element-325">
                <div className="w-8 h-8 rounded-full bg-[#1B3A6B] flex items-center justify-center text-white font-bold text-xs" data-id="element-326">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-327">
                  <p className="font-bold text-[#1C1C2E] text-sm" data-id="element-328">
                    {review.name}
                  </p>
                  <p className="text-xs text-[#8B8BAA]" data-id="element-329">{review.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}